import { Grid, Paper, Typography } from '@mui/material';

export const SecondPolicy = () => {
    return (
        <Paper square sx={{ backgroundColor: '#1976d2', margin: 1 }}>
            <Grid container direction="column" px={2} pb={2} spacing={2}>
                <Grid item container justifyContent="center">
                    <Typography variant="h6" color="white">
                        親の手伝い（当番制）なし
                    </Typography>
                </Grid>
                <Grid item>
                    <Typography variant="body2" color="white">お母さん、お父さんが週末お仕事でも安心して、お子様を預けられます</Typography>
                </Grid>
            </Grid>
        </Paper>
    )
}
